module.exports = __webpack_public_path__ + "static/img/logo2.2a073cd4.png";